import { render, staticRenderFns } from "./SendSpeak.vue?vue&type=template&id=2da19e24&scoped=true&"
import script from "./SendSpeak.vue?vue&type=script&lang=ts&"
export * from "./SendSpeak.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da19e24",
  null
  
)

export default component.exports